import Butter from 'buttercms'

const butterAPI = Butter('ebdc3ec6f48da1349af075ace449cb48e11e4378')

const getLatestPosts = async (args) => {
    const { data } = await butterAPI.post.list(args)
    console.log(data)
    return data
}

const getPost = async (slug) => {
    const { data } = await butterAPI.post.retrieve( slug )
    return data
}

const getProjects = async (args) => {
    const { data } = await butterAPI.content.retrieve(["projects"], { page: 1, page_size: 5, ...args } )
    return data
}

const getBrands = async (args) => {
    const { data } = await butterAPI.content.retrieve(["brands"], { page: 1, page_size: 5, ...args } )
    return data
}

const getTestimonials = async (args) => {
    const { data } = await butterAPI.content.retrieve(["testimonial"], { page: 1, page_size: 5, ...args })
    return data.data
}

export {
    getBrands,
    getPost,
    getProjects,
    getLatestPosts,
    getTestimonials
}


// WEBPACK FOOTER //
// ./src/api/butterCMS.js